module.exports = __webpack_public_path__ + "img/1.dd150de8.png";